<p-blockUI [blocked]="show">
	<ng-template pTemplate="content">
		<div id="loader-spin">
			<div class="spinner-border spinner-loader-border text-warning" role="status">
				<span class="sr-only">{{'g.loading' | translate}}...</span>
			</div>
		</div>
	</ng-template>
</p-blockUI>
